'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPopOpenWidget = undefined;

var _reselect = require('reselect');

var _getPopOpenWidget = require('conversations-schema/operators/message/getPopOpenWidget');

var _getWelcomeMessage = require('./getWelcomeMessage');

var getPopOpenWidget = exports.getPopOpenWidget = (0, _reselect.createSelector)(_getWelcomeMessage.getWelcomeMessage, function () {
  var welcomeMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _getPopOpenWidget.getPopOpenWidget)(welcomeMessage);
});